import { Card, CardBody, Col } from "reactstrap";
import { H1, H2, H3, H4, H5, H6 } from "../../../AbstractElements";
import { BoldFont, Bolder, FontWeightTitle, LightFont, LightsFont, MediumBold, NormalFont, fw300, fw400, fw500, fw600, fw700, fw900 } from "../../../Constants/Constants";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { FontWeightSubTitle } from "../../../Data/UiKits/Typography";

const FontWeight = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={FontWeightTitle} span={FontWeightSubTitle} />
        <CardBody className="d-flex flex-column gap-3">
          <H1 className="f-w-900">{Bolder}<code> {fw900}</code></H1>
          <H2 className="f-w-700">{BoldFont}<code> {fw700}</code></H2>
          <H3 className="f-w-600">{MediumBold}<code> {fw600}</code></H3>
          <H4 className="f-w-500">{NormalFont}<code> {fw500}</code></H4>
          <H5 className="f-w-400">{LightFont}<code> {fw400}</code></H5>
          <H6 className="f-w-300">{LightsFont}<code> {fw300}</code></H6>
        </CardBody>
      </Card>
    </Col>
  );
}
export default FontWeight;